import { render, staticRenderFns } from "./v80d3010m - Copy.vue?vue&type=template&id=55b4928e&scoped=true&"
import script from "./v80d3010m - Copy.vue?vue&type=script&lang=js&"
export * from "./v80d3010m - Copy.vue?vue&type=script&lang=js&"
import style0 from "./v80d3010m - Copy.vue?vue&type=style&index=0&id=55b4928e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b4928e",
  null
  
)

export default component.exports